import * as React from 'react';

function PricingPage() {

  return (
    <stripe-pricing-table
      pricing-table-id={process.env.REACT_APP_STRIPE_PRICING_TABLE_ID}
      publishable-key={process.env.REACT_APP_STRIPE_PK}
    >
    </stripe-pricing-table>
  );
}

export default PricingPage;